module.exports = __webpack_public_path__ + "static/images/bike.FMHF6ws.svg";